import { render } from "./TestMetadataDetails.vue?vue&type=template&id=b446fdf0"
import script from "./TestMetadataDetails.vue?vue&type=script&lang=js"
export * from "./TestMetadataDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__